import Typography from '@mui/material/Typography';

import config from '../../config/config';

const CustomInputLabel = props => (
  <Typography
    variant='largeBoldLoose'
    sx={{
      padding: '7.5px 10px 3px 0',
      ...(props.sx || {}),
    }}
  >
    {props.children}
    {
      props.required
        ? <span style={{ color: config().colors.error }}> *</span>
        : ''
    }
  </Typography>
);

export default CustomInputLabel;
